const axios = require('axios');
import {
	serverUrl
} from '../properties'
const dataUrl = serverUrl;

const parseJwt = (token) => {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
}

const isUserInGroup = (token, groupName) => {
  const groups = token["cognito:groups"] || [];
  return groups.map(g => g.toLowerCase()).includes(groupName.toLowerCase());
}


export default {
	namespaced: true,
	state: {
        accountRoles: [],
        isSuperUser: false,
        isGKAdmin: false
	},
	mutations: {
        hydrateIsGKAdmin(state) {
            try {
                const session = JSON.parse(localStorage.getItem('session'));
                const token = parseJwt(session.idToken);
                state.isGKAdmin = isUserInGroup(token, "gkclientaccountadministrators");
            } catch {
                state.isGKAdmin = false
            }
        },
        hydrateIsSuperUser(state) {
            try {
                const session = JSON.parse(localStorage.getItem('session'));
                const token = parseJwt(session.idToken);
                state.isSuperUser = isUserInGroup(token, "gkclientsuperusers");
            } catch {
                state.isSuperUser =  false;
            }
        },

    },
    getters: {
        hasAccountAccess: (state, getters) => {
            return (client_id) => {
                if (!client_id) {
                    return false
                }
                if (state.isSuperUser || state.isGKAdmin) {
                    return true
                }
                // console.log('CLIENT ID: ', client_id)
                // console.log(state.accountRoles)
                const selectedAccount = state.accountRoles.filter(a => a.client_id == client_id)[0]
                const rolesForAccount = selectedAccount ? selectedAccount.roles : []
				return rolesForAccount.some( a => ['GO_BRAND', 'ACCOUNT_MANAGER', 'GO_RETAIL'].includes(a))
            }
		},
	},
	actions: {
        getAccountRoles({
            commit,
            state,
            getters,
            rootGetters,
            rootState
        }, payload) {
            return new Promise((resolve, reject) => {
                let url = dataUrl + "/auth/getRoles"
                axios({
                    url: url,
                    method: 'POST',
                    data: payload,
                    headers: rootGetters.fetchHeader,
                    responseType: 'json'
                }).then((response) => {
                    resolve(response.data)
                }).catch((error) => {
                    console.log(error)
                })
            })
        },
        hasSellerProductAccess({
            commit,
            state,
            getters,
            rootGetters,
            rootState
        }, payload) {
            return new Promise((resolve, reject) => {
                let url = dataUrl + "/auth/sellerProduct"
                axios({
                    url: url,
                    method: 'POST',
                    data: payload,
                    headers: rootGetters.fetchHeader,
                    responseType: 'json'
                }).then((response) => {
                    resolve(response.data)
                }).catch((error) => {
                    console.log(error)
                })
            })
        },
        hasVendorProductAccess({
            commit,
            state,
            getters,
            rootGetters,
            rootState
        }, payload) {
            return new Promise((resolve, reject) => {
                let url = dataUrl + "/auth/vendorProduct"
                axios({
                    url: url,
                    method: 'POST',
                    data: payload,
                    headers: rootGetters.fetchHeader,
                    responseType: 'json'
                }).then((response) => {
                    resolve(response.data)
                }).catch((error) => {
                    console.log(error)
                })
            })
        },
        hasCampaignAccess({
            commit,
            state,
            getters,
            rootGetters,
            rootState
        }, payload) {
            return new Promise((resolve, reject) => {
                let url = dataUrl + "/auth/campaign"
                axios({
                    url: url,
                    method: 'POST',
                    data: payload,
                    headers: rootGetters.fetchHeader,
                    responseType: 'json'
                }).then((response) => {
                    resolve(response.data)
                }).catch((error) => {
                    console.log(error)
                })
            })
        },
        hasDSPAccess({
            commit,
            state,
            getters,
            rootGetters,
            rootState
        }, payload) {
            return new Promise((resolve, reject) => {
                let url = dataUrl + "/auth/dspOrder"
                axios({
                    url: url,
                    method: 'POST',
                    data: payload,
                    headers: rootGetters.fetchHeader,
                    responseType: 'json'
                }).then((response) => {
                    resolve(response.data)
                }).catch((error) => {
                    console.log(error)
                })
            })
        },
        hydrateAuth({commit}, state) {
            console.log('hydrating auth')
            commit('hydrateIsGKAdmin')
            commit('hydrateIsSuperUser')
        }
    }
}